import React, { FC } from 'react';

import { Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { isConPlatform } from 'utils';

export const NotFound: FC<{ message?: string }> = ({ children, message }) => (
  <>
    {isConPlatform ? (
      <Row justify="center" className="filter-not-found-experiences__error">
        <FormattedMessage
          id={message ?? 'page.marketing-materials.experiences.no-found'}
        />
      </Row>
    ) : (
      <Row className="filter-not-found">
        <Row justify="center" className="filter-not-found__icon">
          <div className="filter-not-found__icon-container">
            <div className="icon icon--search filter-not-found__icon-container--search" />
            <div className="icon icon--close filter-not-found__icon-container--close" />
          </div>
        </Row>
        <Row justify="center" className="filter-not-found__error">
          <FormattedMessage
            id={message ?? 'page.marketing-materials.no-found'}
          />
        </Row>
      </Row>
    )}
    {children}
  </>
);
